import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgSwitch = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 18, height: 16, viewBox: "0 0 18 16", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { d: "M12.47 0.47a0.75 0.75 0 0 1 1.06 0l3.5 3.5a0.75 0.75 0 0 1 0 1.06l-3.5 3.5a0.75 0.75 0 1 1-1.06-1.06l2.22-2.22H1.75a0.75 0.75 0 0 1 0-1.5h12.94l-2.22-2.22a0.75 0.75 0 0 1 0-1.06z" }),
  /* @__PURE__ */ jsx("path", { d: "M5.53 7.47a0.75 0.75 0 0 1 0 1.06l-2.22 2.22h12.94a0.75 0.75 0 0 1 0 1.5H3.31l2.22 2.22a0.75 0.75 0 1 1-1.06 1.06l-3.5-3.5a0.75 0.75 0 0 1 0-1.06l3.5-3.5a0.75 0.75 0 0 1 1.06 0z" })
] });
const ForwardRef = /* @__PURE__ */ forwardRef(SvgSwitch);
export { ForwardRef as ReactComponent };
import assetUrl from "/home/runner/work/UpstriveEducation-Teacher/UpstriveEducation-Teacher/src/assets/svg/switch.svg?url";
export default assetUrl;
